// This file is auto-generated. Do not edit directly.
import * as z from "zod/v4";

// Zod schema for permission keys
export const zPermissionKey = z.enum([
  "admin",
  "fortnox",
  "blacklistlist",
  "mergecustomer",
  "reading",
  "developer",
  "approveexaminer",
  "examinate",
  "edit:customer",
  "edit:journals",
  "dismiss:portalupdates",
  "view:dashboard",
  "view:reports",
  "view:todo",
  "view:customers",
  "view:linecheck",
  "view:cultivation",
  "view:lungmask",
  "view:read",
  "view:trikin",
  "view:pcr",
  "view:elisa",
  "view:disposal",
  "view:feed",
  "view:registration",
  "view:quickregistration",
  "view:email",
  "view:invoices",
  "view:statistics",
  "view:competences",
  "view:unfinished",
  "history",
]);

// TypeScript type derived from the schema
export type PermissionKey = z.infer<typeof zPermissionKey>;

// Zod schema for Permission object
export const zPermission = z.object({
  key: zPermissionKey,
  name: z.string(),
  description: z.string().nullable(),
  group: z.string(),
  manual: z.boolean(),
});

// TypeScript type derived from the schema
export type Permission = z.infer<typeof zPermission>;
